import React from "react";
import { FaPhotoVideo, FaTimes } from "react-icons/fa";

import {
  isVideoPostMedia,
  resolvePostMediaSrc,
} from "../../../utils/postMedia";

export default function EditPostMediaReplacement({
  post,
  mediaReplacement,
  t,
  disabled,
}) {
  const currentMediaSrc = resolvePostMediaSrc(post);
  const selectedMediaType = mediaReplacement.mediaType;
  const selectedPreviewUrl = mediaReplacement.previewUrl;
  const inputId = `edit-post-media-${post?.id || "new"}`;

  return (
    <section className="edit-post-media-replacement">
      <div className="edit-post-media-header">
        <h3>{t("post_edit_media_section_title")}</h3>
        <div className="edit-post-media-actions">
          <input
            ref={mediaReplacement.fileInputRef}
            id={inputId}
            type="file"
            accept="image/*,video/*"
            className="edit-post-media-input"
            onChange={mediaReplacement.handleFileChange}
            disabled={disabled}
          />
          <label
            className={`edit-post-media-pick-btn${disabled ? " is-disabled" : ""}`}
            htmlFor={inputId}
          >
            <FaPhotoVideo aria-hidden="true" />
            <span>{t("post_edit_media_choose")}</span>
          </label>
          {mediaReplacement.hasSelection ? (
            <button
              type="button"
              className="edit-post-media-clear-btn"
              onClick={mediaReplacement.clearSelectedMedia}
              disabled={disabled}
            >
              <FaTimes aria-hidden="true" />
              <span>{t("post_edit_media_clear")}</span>
            </button>
          ) : null}
        </div>
      </div>

      <div className="edit-post-media-preview-grid">
        <div className="edit-post-media-preview-block">
          <span className="edit-post-media-label">
            {t("post_edit_media_current_label")}
          </span>
          {currentMediaSrc ? (
            isVideoPostMedia(post) ? (
              <video
                src={currentMediaSrc}
                controls
                className="edit-post-media-preview"
              />
            ) : (
              <img
                src={currentMediaSrc}
                alt={t("post_media")}
                className="edit-post-media-preview"
              />
            )
          ) : (
            <div className="edit-post-media-empty">
              {t("post_edit_media_no_current")}
            </div>
          )}
        </div>

        {mediaReplacement.hasSelection ? (
          <div className="edit-post-media-preview-block">
            <span className="edit-post-media-label">
              {t("post_edit_media_replacement_label")}
            </span>
            {selectedPreviewUrl && selectedMediaType === "video" ? (
              <video
                src={selectedPreviewUrl}
                controls
                className="edit-post-media-preview"
              />
            ) : selectedPreviewUrl && !mediaReplacement.previewUnavailable ? (
              <img
                src={selectedPreviewUrl}
                alt={t("post_edit_media_preview_alt")}
                className="edit-post-media-preview"
                onError={mediaReplacement.handlePreviewError}
              />
            ) : (
              <div className="edit-post-media-empty">
                {mediaReplacement.selectedFile?.name ||
                  t("post_edit_media_replacement_label")}
              </div>
            )}
          </div>
        ) : null}
      </div>

      {mediaReplacement.errorKey ? (
        <div className="edit-post-media-error" role="alert">
          {t(mediaReplacement.errorKey)}
        </div>
      ) : null}
    </section>
  );
}
